import bonk from './assets/sounds/bonk.ogg'
import './CWindow.css';
import { render, createPortal } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { useState, useEffect } from "react";
import Vector2 from './Vector2';
import { tab } from '@testing-library/user-event/dist/tab';

function lerp(from, to, i) {
    return from + (to - from) * i;
}

function movetowards(from, to, i) {
    if (from < to) return Math.min(from + i, to);
    return Math.max(from - i, to);
}

function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

function absMax(a, b) {
    if (Math.abs(a) > Math.abs(b)) return a;
    return b;
}

function bounce(value, min, max) {
    if (value < min) return min + (min - value);
    if (value > max) return max - (value % max);
    return value;
}

// https://stackoverflow.com/questions/2234979/how-to-check-in-javascript-if-one-element-is-contained-within-another
function childOf(/*child node*/c, /*parent node*/p){ //returns boolean
    while((c=c.parentNode)&&c!==p); 
    return !!c; 
}

function pxToVW(px) { return (100 * parseFloat(px)) / window.innerWidth + 'vw'; }
function pxToVH(px) { return (100 * parseFloat(px)) / window.innerHeight + 'vh'; }
function vwToPX(vw) { return (window.innerWidth * parseFloat(vw)) / 100; }
function vhToPX(vh) { return (window.innerHeight * parseFloat(vh)) / 100; }

class HandleWindow {
    static focused;

    static unfocus(jsx) {
        // console.log('attempting to unfocus on ' + jsx.getAttribute('id') + (this.focused ? (' with matching ' + this.focused.getAttribute('id')) : ' with nothing focused'));
        if (jsx && jsx != this.focused) return;
        // console.log(' unfocus success');
        if (this.focused) {
            this.focused.setAttribute('inFocus', 'false');
            this.focused.setAttribute('opening', 'false');
            document.getElementById(this.focused.id + 'button').setAttribute('state', 'unfocused');
        }
        this.focused = null;
    }

    static inFocus(jsx) {
        return this.focused == jsx;
    }

    static focusList = [];
    static focusOn(jsx) {
        // console.log('attempting to focus on ' + jsx.getAttribute('id') + (this.focused ? (' with previous focus ' + this.focused.getAttribute('id')) : ' with no previous focus'));
        if (this.inFocus(jsx) || jsx.getAttribute('closing') == 'true') return;
        // console.log(' focus success');
        if (this.focused) {
            this.focused.setAttribute('inFocus', 'false');
            this.focused.setAttribute('opening', 'false');
            document.getElementById(this.focused.id + 'button').setAttribute('state', 'unfocused');
        }

        if (this.focusList.includes(jsx)) this.focusList.splice(this.focusList.indexOf(jsx), 1);
        this.focusList.push(jsx);

        if (jsx.getAttribute('closing') == 'true') {
            jsx.setAttribute('closing', 'false');
            jsx.setAttribute('opening', 'true');
        }

        // console.log('pre');
        // console.log(jsx);
        this.focused = jsx;
        jsx.setAttribute('inFocus', 'true');
        document.getElementById(jsx.id + 'button').setAttribute('state', 'open');

        for (let i = 0; i < this.focusList.length; i++) {
            this.focusList[i].style['z-index'] = i + 1;
        }

        console.log(this.focusList);

        // jsx.parentElement.appendChild(jsx);
        // console.log('post');
        // console.log(jsx);
    }

    static taskbuttons = {};
    static addTaskbar(jsx) {
        if (!this.taskbuttons[jsx.props.id]) this.taskbuttons[jsx.props.id] = [];
        this.taskbuttons[jsx.props.id].push(jsx);
        render(<>{Object.values(this.taskbuttons)}</>, document.getElementById('TaskbarContents'));
    }

    static removeTaskbar(jsx) {
        if (!this.taskbuttons[jsx.props.id]) return;
        const indexOf = this.taskbuttons[jsx.props.id].indexOf(jsx);
        this.taskbuttons[jsx.props.id].splice(indexOf, 1);
        render(<>{Object.values(this.taskbuttons)}</>, document.getElementById('TaskbarContents'));
    }
}

function CWindow({ open, offset, children }) {
    let tabby;
    let closed = open != 'true';
    offset = offset || {x: 0, y: 0}
    const singleTab = !Array.isArray(children.contents);
    console.log('creating ' + children.id + ' with closed as ' + closed);

    let curSize;
    let runningBounce = false;
    let windowVelo = new Vector2(0, 0);

    let theworld = false;
    let unstoppable = false;

    let bounds = [new Vector2(0, 0), new Vector2(0, 0)];
    const refreshBounds = () => {
        bounds[0].set(-curSize.x * 0.75, window.innerWidth - curSize.x * 0.25);
        bounds[1].set(-curSize.y * 0.75, window.innerHeight - curSize.y * 0.25);
        return bounds;
    }

    const limbo = () => {
        const focuss = HandleWindow.inFocus(tabby);
        if (closed || focuss) toggleVis();
        else HandleWindow.focusOn(tabby);
    }

    const debugFun = (e) => {
        // console.log('uwu aaa ' + e.key + ' ' + children.id);
        if (e.key == 'z') {theworld = !theworld; tabby.setAttribute('timefrozen', '' + theworld)};
        if (e.key == 'x') {unstoppable = !unstoppable; tabby.setAttribute('nodecel', '' + unstoppable)};
        if (e.key == 'c') console.log(children.id + ' is ' + (closed ? 'closed' : 'open'));
        if (e.key == 'v') console.log('focused: ' + (HandleWindow.focused ? HandleWindow.focused.getAttribute('id') : 'none'));
    };

    const centerPos = () => {
        const size = recalcSize();
        tabby.style.left = pxToVW((window.innerWidth - size.x) * 0.5 + vwToPX(offset.x || 0));
        tabby.style.top = pxToVH((window.innerHeight - size.y) * 0.5 + vwToPX(offset.y || 0));
    }

    // Window drag logic
    let target;
    let oldPos;
    let taskbuttoned;
    useEffect( () => {
        let oldCursor = 'default';

        // taskbar owo
        const taskbutton = <button id={children.id + 'button'} state='closed' className='taskbutton' onMouseDown={e => e.stopPropagation()} onMouseUpCapture={limbo} type="button"> {children.icon || children.id} </button>;
        let updater;

        // hehehe window go bonk
        let bounced = new Vector2(0, 0);
        let prediction = new Vector2(0, 0);
        let lastBounce = 0;

        let lastUpdate = Date.now();
        let elapsed = 0;
        const update = () => {
            const curUpdate = Date.now();
            elapsed = (curUpdate - lastUpdate) * 0.001;
            lastUpdate = curUpdate;

            if (target || (!theworld && windowVelo.length != 0)) {
                refreshBounds();
                prediction.set(vwToPX(tabby.style.left), vhToPX(tabby.style.top));

                const yea = () => 
                bounced.set(bounce(prediction.x, bounds[0].x, bounds[0].y),
                            bounce(prediction.y, bounds[1].x, bounds[1].y));

                if (!target) {
                    prediction.x += windowVelo.x * elapsed * 100;
                    prediction.y += windowVelo.y * elapsed * 100;
                    yea();

                    tabby.style.left = pxToVW(bounced.x);
                    tabby.style.top = pxToVH(bounced.y);

                    if (!unstoppable) windowVelo.length = movetowards(windowVelo.length, 0, Math.min(windowVelo.length * elapsed * 0.9, 24) + windowVelo.length * 0.005);
                } else {
                    windowVelo.length = movetowards(windowVelo.length, 0, windowVelo.length * 0.75 + 1);
                    yea();
                }

                let curBounce = false;
                ['x', 'y'].forEach(i => {
                    if (prediction[i] != bounced[i]) {
                        curBounce = true;
                        // target ? (-windowVelo[i] + absMax(-windowVelo[i], (bounced[i] - prediction[i]) * 0.5)) * 0.5 :
                        windowVelo[i] = -windowVelo[i];

                        if (i == 'x') tabby.style.left = pxToVW(bounced.x);
                        else tabby.style.top = pxToVH(bounced.y);
                    }
                });

                // console.log(children.id + ' ' + lastBounce)
                if (curBounce && (!target || lastBounce == 0)) {
                    new Audio(bonk).play();
                    lastBounce = 10;
                } else if (lastBounce > 0) {
                    lastBounce--;
                }
            }
        }

        const grabWindow = (e) => {
            e = e || window.event;
            if (!closed) HandleWindow.focusOn(tabby);

            if (e.target && (e.target.getAttribute('windowdrag') || e.shiftKey)) {
                e.preventDefault();
                e.stopPropagation();
                target = e.target;

                oldCursor = target.style.cursor;
                document.body.style.cursor = 'grabbing';
                target.style.cursor = 'grabbing';
                oldPos = [e.clientX, e.clientY];
            }
        }

        const grabTouch = (event) => {
            event = event || window.event;
            const e = event.touches[0];
            if (e.target && e.target.getAttribute('windowdrag')) {
                target = e.target;
                oldPos = [e.clientX, e.clientY];
            }
        }

        const unfocus = (e) => {
            e = e || window.event;
            if (e.target.id == 'App') HandleWindow.unfocus(tabby);
        }

        const moveWindow = (e) => {
            e = e || window.event;
            if (target) {
                // tabby.style.left = pxToVW(clamp(vwToPX(tabby.style.left) + e.clientX - oldPos[0], bounds[0].x, bounds[0].y));
                // tabby.style.top = pxToVH(clamp(vhToPX(tabby.style.top) + e.clientY - oldPos[1], bounds[1].x, bounds[1].y));

                tabby.style.left = pxToVW(vwToPX(tabby.style.left) + e.clientX - oldPos[0]);
                tabby.style.top = pxToVH(vhToPX(tabby.style.top) + e.clientY - oldPos[1]);

                windowVelo.x = (windowVelo.x + e.clientX - oldPos[0]) * 0.6;
                windowVelo.y = (windowVelo.y + e.clientY - oldPos[1]) * 0.6;

                oldPos[0] = e.clientX;
                oldPos[1] = e.clientY;
            }
        }

        const moveTouch = (e) => {
            moveWindow(e.touches[0]);
        }

        const endDrag = () => {
            document.body.style.cursor = null;
            if (target) target.style.cursor = oldCursor;
            target = null;
        };

        tabby = document.getElementById(children.id);
        setTimeout(() => {
            tabby = document.getElementById(children.id);
            HandleWindow.addTaskbar(taskbutton);
            taskbuttoned = document.getElementById(children.id + 'button');
            curSize = getSize();

            // Add window grab logic
            tabby.addEventListener("mousedown", grabWindow);
            tabby.addEventListener("touchstart", grabTouch);
            document.addEventListener("mousedown", unfocus);
            document.addEventListener("mousemove", moveWindow);
            document.addEventListener("touchmove", moveTouch);

            // Window resizing logic
            window.addEventListener('resize', recalcSize);
            window.addEventListener('mouseup', endDrag);
            window.addEventListener('touchend', endDrag);

            // keybind funni
            window.addEventListener('keydown', debugFun);

            // Force-open the first tab
            setTimeout(() => {
                tabby.setAttribute('opening', 'false');
                tabby.setAttribute('inFocus', 'noAnim');
                tabby.setAttribute('closing', 'false');

                if (!singleTab) {
                    var clickEvent = new Event("mousedown", { bubbles: true, cancelable: true });
                    tabby.getElementsByClassName('windowBar')[0].firstChild.dispatchEvent(clickEvent);
                }

                centerPos();

                if (closed) {
                    tabby.setAttribute('inFocus', 'false');
                    tabby.setAttribute('closing', 'noAnim');
                } else {
                    tabby.setAttribute('inFocus', 'true');
                    toggleVis(false);
                }

                tabby.setAttribute('loading', 'false');
            }, 0); // janky uwu

            if (!runningBounce) {
                runningBounce = true;
                updater = setInterval(update, 12.5);
            }
        }, 0)

        return () => {
            HandleWindow.removeTaskbar(taskbutton);

            clearInterval(updater);

            // Remove window grab logic
            tabby.removeEventListener("mousedown", grabWindow);
            tabby.removeEventListener("touchstart", grabTouch);
            document.removeEventListener("mousedown", unfocus);
            document.removeEventListener("mousemove", moveWindow);
            document.removeEventListener("touchmove", moveTouch);

            // Window resizing logic
            window.removeEventListener('resize', recalcSize);
            window.removeEventListener('mouseup', endDrag);
            window.removeEventListener('touchend', endDrag);

            // keybind funni
            window.removeEventListener('keydown', debugFun);
            HandleWindow.unfocus(tabby);
        }
    }, [])

    // Tab focus logic
    let tabFocus;
    const focus = (e) => {
        e = e || window.event;
        e.stopPropagation();
        if (e.target !== tabFocus) {
            if (tabFocus)
                tabFocus.setAttribute('focused', false);
            tabFocus = e.target;
            e.target.setAttribute('focused', true);
    
            // jank 100!
            tabby.getElementsByClassName('windowContent')[0].innerHTML = e.target.getElementsByClassName('tabcontent')[0].innerHTML;
        }
    }

    // Get tab content size recursively
    const getSize = () => {
        let lock = true;
        const heightStopper = tabby.getElementsByClassName('windowContent')[0];
        let parent = tabby.getElementsByClassName('windowContent')[0].firstChild;

        let width = new Vector2(Infinity, -Infinity); // Left, Right
        let height = new Vector2(Infinity, -Infinity); // Up, Down
        let calcSize = new Vector2(0, 0);

        while (parent != tabby) {
            lock = parent != tabby;
            let owo = parent.children;

            for (let i = 0; i < owo.length; i++) {
                const uwu = owo[i].getBoundingClientRect();
                if (uwu.width <= 0) continue;

                if (parent != heightStopper) {
                    if (uwu.left < width.x) width.x = uwu.left;
                    if (uwu.right > width.y) width.y = uwu.right;
                } else if (height.x == Infinity || height.y == -Infinity) {
                    width.x = heightStopper.offsetLeft;
                    width.y = heightStopper.offsetLeft + heightStopper.offsetWidth;
                    calcSize.extraData.noWidth = true;
                }

                if (parent != heightStopper || height.x == Infinity || height.y == -Infinity) {
                    if (uwu.top < height.x) height.x = uwu.top;
                    if (uwu.bottom > height.y) height.y = uwu.bottom;
                }

                calcSize.set(width.y - width.x, height.y - height.x);
            }

            parent = parent.parentElement;
        }

        calcSize.y += tabby.getElementsByClassName('windowBar')[0].offsetHeight;
        return calcSize;
    }

    // Fixes windowBar + sideBar on resize/tab change
    const recalcSize = () => {
        tabby.setAttribute('opening', 'false');
        tabby.setAttribute('inFocus', 'noAnim');
        tabby.setAttribute('closing', 'false');

        // console.log(tabby);
        const contents = tabby.getElementsByClassName('windowContent')[0];
        curSize = getSize();

        contents.style.width = curSize.x + 'px';
        contents.style.height = (curSize.y - tabby.getElementsByClassName('windowBar')[0].offsetHeight) + 'px';

        refreshBounds();

        if (!curSize.extraData.noWidth)
        tabby.getElementsByClassName('windowBar')[0].style.width = curSize.x + 'px';
        tabby.getElementsByClassName('sideBar')[0].style.height = curSize.y + 'px';

        tabby.setAttribute('inFocus', 'false');
        if (closed) {
            tabby.setAttribute('closing', 'noAnim');
        } else {
            tabby.setAttribute('inFocus', HandleWindow.inFocus(tabby) ? 'noAnim' : 'disAnim');
        }

        return curSize; // reusability
    }

    let timeouters;
    const toggleVis = (forceValue = null, resetPos = false) => {
            if (timeouters) {
                clearTimeout(timeouters);
            if (closed) windowVelo.length = 0;
            else tabby.setAttribute('opening', 'false');
        }

        console.log(children.id + ' toggling from ' + closed + ' to ' + ((forceValue == null) ? !closed : forceValue));
        closed = (forceValue == null) ? !closed : forceValue;

        if (closed) {
            HandleWindow.unfocus(tabby);
            taskbuttoned.setAttribute('state', 'closed');
            tabby.setAttribute('closing', 'true');
            tabby.setAttribute('opening', 'false');
            timeouters = setTimeout(() => {
                windowVelo.length = 0;
                if (resetPos) centerPos();
            }, 500); // janky owo
        } else {
            taskbuttoned.setAttribute('state', 'open');
            tabby.setAttribute('closing', 'false');
            HandleWindow.focusOn(tabby);
            tabby.setAttribute('opening', 'true');
            tabby.setAttribute('inFocus', 'noAnim');
            timeouters = setTimeout(() => {
                tabby.setAttribute('opening', 'false');
            }, 500); // janky owo
        }
    }

    if (singleTab) {
        return <div className="CWindow" id={children.id}
                loading='true' style={{left: '0px', top: '0px'}}>
                    <div className="sideBar" windowdrag="true"
                    style={{width: '1.5em'}}>
                    </div>
    
                    <div className="windowBar" windowdrag="true"
                    style={{height: '1.5em'}}>
                        <div className="singleTab">{ children.id }</div>
                        <div id='blanktab' windowdrag="true"/>
                        <button onMouseUp={() => toggleVis(true, true)} type="button">X</button>
                    </div>
    
                    <div className="windowContent">
                        { children.contents }
                    </div>
                </div>
    } else {
        // Create tabs
        let tabs = [];
        for (let obj in children.contents) {
            tabs.push(<div className="tab"
            onMouseDown={focus} >
                <uwu className="tabcontent">{children.contents[obj].content}</uwu>
                {children.contents[obj].title}
            </div>);
        }

        return <div className="CWindow" id={children.id}
                loading='true' style={{left: '0px', top: '0px'}}>
                    <div className="sideBar" windowdrag="true"
                    style={{width: '1.5em'}}>
                    </div>
    
                    <div className="windowBar" windowdrag="true"
                    style={{height: '1.5em'}}>
                        { tabs }
                        <div id='blanktab' windowdrag="true"/>
                        <button onMouseUp={() => toggleVis(true)} type="button">X</button>
                    </div>
    
                    <div className="windowContent">
                        { children.contents[0].content }
                    </div>
                </div>
    }
}

export default CWindow;